module.exports = __webpack_public_path__ + "static/media/n.cc7f3ab7.png";